import { useMutation } from "react-query";
import { getInvoiceById } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetInvoiceById = () => {
  return useMutation(getInvoiceById);
};
